import React, { Component } from 'react';
import styled from 'styled-components';
import onClickOutside from 'react-onclickoutside';
import { fonts } from 'bench-style-constants';

import MonthRangePicker from './MonthRangePicker';
import Popover from './Popover';
import Button from './Button';

const Wrapper = styled.div`
  position: relative;
  font-family: ${fonts.circular};
`;

const PopoverWrap = styled.div`
  position: absolute;
  top: 100%;
  right: 0;
  z-index: 1;
`;

export const MonthYear = styled.div`
  display: flex;
  flex-direction: row;
`;

export type MonthRangePopoverProps = {
  onSubmit: (restoreLastChecks: boolean, startDate: string, endDate: string) => void;
};

export type MonthRangePopoverState = {
  popOverActive: boolean;
};

class MonthRangePopover extends Component<MonthRangePopoverProps, MonthRangePopoverState> {
  constructor(props) {
    super(props);

    this.state = {
      popOverActive: false,
    };
  }

  onTogglePopover = () => {
    this.setState(prevState => ({
      popOverActive: !prevState.popOverActive,
    }));
  };

  onSubmit = (restoreLastChecks, startDate, endDate) => {
    this.setState({
      popOverActive: false,
    });

    if (startDate && endDate) {
      this.props.onSubmit(restoreLastChecks, startDate, endDate);
    }
  };

  // Expected by `onClickOutside` which will handle clicks on the document to dismiss the popover.
  handleClickOutside = () => {
    this.setState({ popOverActive: false });
  };

  render() {
    const { popOverActive } = this.state;

    return (
      <Wrapper>
        <Button onClick={this.onTogglePopover}>
          <MonthYear data-test-id="month-range-popover-toggle">Select Review Period</MonthYear>
        </Button>
        {popOverActive && (
          <PopoverWrap>
            <Popover right="85px" data-test-id="month-range-popover">
              <MonthRangePicker onSubmit={this.onSubmit} />
            </Popover>
          </PopoverWrap>
        )}
      </Wrapper>
    );
  }
}

export default onClickOutside(MonthRangePopover);
